import Decimal from 'decimal.js';
/*
  Note: Almost all process.env.* references must be prefixed with "RAZZLE_".
  See https://github.com/jaredpalmer/razzle#environment-variables
*/

// --ENV
export const ENVIRONMENT = process.env.ENVIRONMENT;
export const VERSION = process.env.RAZZLE__VERSION;
export const PUBLIC_PATH = process.env.PUBLIC_PATH;

export const IS_DEVELOPMENT = ['development', 'ted'].includes(ENVIRONMENT);
export const IS_PRODUCTION = ENVIRONMENT === 'production';
export const IS_SERVER = process.env.BUILD_TARGET === 'server';

export const HOTELS_API_URL = IS_SERVER
  ? `${process.env.RAZZLE__HOTELS_API_HOST}${process.env.RAZZLE__HOTELS_API_BASE_PATH}`
  : process.env.RAZZLE__HOTELS_API_BASE_PATH;

export const SENTRY_DSN = process.env.RAZZLE__SENTRY_DSN;
export const QFF_LOGIN_BUNDLE_URL = process.env.RAZZLE__QFF_LOGIN_BUNDLE_URL;
export const SIMPLICITY_BUNDLE_URL = process.env.RAZZLE__SIMPLICITY_BUNDLE_URL;
export const LOG_ANALYTICS = process.env.RAZZLE__LOG_ANALYTICS;
export const GTM_ID = process.env.RAZZLE__GTM_ID;
export const GOOGLE_MAPS_API_KEY = process.env.RAZZLE__GOOGLE_MAPS_API_KEY;
export const GOOGLE_MAPS_STATIC_API_URL = process.env.RAZZLE__GOOGLE_MAPS_STATIC_API_URL;
export const HOTELS_HOST = process.env.RAZZLE__HOTELS_HOST || 'https://www.qantas.com';
export const SPLIT_BROWSER_REFRESH_RATE_SECS = process.env.RAZZLE__SPLIT_BROWSER_REFRESH_RATE_SECS;
export const SNARE_JS_URL = process.env.RAZZLE__SNARE_JS_URL;
export const MASTERCARD_HOST = process.env.RAZZLE__MASTERCARD_HOST;
export const MASTERCARD_VERSION = process.env.RAZZLE__MASTERCARD_VERSION;
export const MASTERCARD_MERCHANT_ID = process.env.RAZZLE__MASTERCARD_MERCHANT_ID;
export const ADYEN_API_VERSION = process.env.RAZZLE__ADYEN_API_VERSION;
export const ADYEN_MERCHANT_ID = process.env.RAZZLE__ADYEN_MERCHANT_ID;
export const ADYEN_CLIENT_KEY = process.env.RAZZLE__ADYEN_CLIENT_KEY;
export const ADYEN_ENVIRONMENT = process.env.RAZZLE__ADYEN_ENVIRONMENT;
export const BOOKING_CONFIRMATION_NPS_SURVEY_URL = process.env.RAZZLE__BOOKING_CONFIRMATION_NPS_SURVEY_URL;
export const SALESFORCE_ORG_ID = process.env.RAZZLE__SALESFORCE_ORG_ID;
export const SALESFORCE_DEPLOYMENT_ID = process.env.RAZZLE__SALESFORCE_DEPLOYMENT_ID;
export const SALESFORCE_LIVE_CHAT_ID = process.env.RAZZLE__SALESFORCE_LIVE_CHAT_ID;
export const RECAPTCHA_SITE_KEY = process.env.RAZZLE__RECAPTCHA_SITE_KEY;
export const LUXE_HOST = process.env.RAZZLE__LUXE_HOST;
export const HOLIDAY_PACKAGES_HOST = process.env.RAZZLE__HOLIDAY_PACKAGES_HOST;

// --Direct config
export const ROUTER_BASE_NAME = '/hotels';
export const SEARCH_DATE_FORMAT = 'yyyy-MM-dd';
export const DISPLAY_DATE_FORMAT = 'EEE d MMM, yyyy';
export const LIST_SEARCH_LIMIT = 20;
export const LIST_DEALS_LIMIT = 3;
export const DEPOSIT_PAY_MINIMUM_DAYS_TO_CHECK_IN = 21;
export const ALLOWED_DEALS_QUERY_PARAMS = ['location', 'adults', 'children', 'infants', 'checkIn', 'checkOut', 'sortBy'];
export const MOBILE_MAP_SEARCH_LIMIT = 100;
export const DESKTOP_MAP_SEARCH_LIMIT = 50;
export const AUTH_REFRESH_INTERVAL = 90000; // refresh auth state to stay logged in
export const TRIPADVISOR_PARTNER_ID = 'D56A68B2E1B7448899A557EB51112C66';
export const MIN_POINTS_AMOUNT = new Decimal(5000);
export const DEPOSIT_PAY_PERCENTAGE = new Decimal(20);
export const SALESFORCE_LIVE_CHAT_HOST = 'https://d.la1-c2-ukb.salesforceliveagent.com';
export const RECAPTCHA_JS = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
